const defaultLocale: Intl.LocalesArgument = 'pl'

const defaultOptions: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
}

type Config = {
  locale?: Intl.LocalesArgument
  options?: Intl.DateTimeFormatOptions
}

const timeInBracketsFormatter = (date: string) => date.toString().replace(/, | o /, ' (') + ')'

export default function formatDate(date: string | number, config?: Config) {
  const locale = config?.locale || defaultLocale
  const options = config?.options || defaultOptions

  return config
    ? new Date(date).toLocaleDateString(locale, options)
    : timeInBracketsFormatter(new Date(date).toLocaleDateString(locale, options))
}
